export const CALCULATE = 'CALCULATE';

export const ADD_MATERIAL = 'ADD_MATERIAL';
export const APPEND_MATERIALS = 'APPEND_MATERIAL';

export const SET_MATERIAL_TO_COURT = 'SET_MATERIAL_TO_COURT';

export const MATERIALS = 'materials';
export const STATUS_FREE = 'STATUS_FREE';
export const STATUS_BUSY = 'STATUS_BUSY';
export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const SAVE_DELTA_TIME = 5 * SECOND;


export const ADD_COURT = 'ADD_COURT';
export const ADD_JUDGE = 'ADD_JUDGE';

export const ADD_INFORMER = 'ADD_INFORMER';
export const UPDATE_INFORMER = 'UPDATE_INFORMER';

export const ADD_SECRETARY = 'ADD_SECRETARY';

export const SET_MATERIAL_TO_JUDGE = 'SET_MATERIAL_TO_JUDGE';

export const UPDATE_COURT = 'UPDATE_COURT';
export const RESET_GAME = 'RESET_GAME';

export const BUY_UPGRADE = 'BUY_UPGRADE';
export const SET_SHOWED_SHARE_BANNER = 'SET_SHOWED_SHARE_BANNER';

export const SET_UPGRADES_AVAILABLE = 'SET_UPGRADES_AVAILABLE';

export const LOCAL_STORAGE_KEY = 'game-state-clicker';
export const PHASE_TWO_STAGE = 9;
